module.exports = __webpack_public_path__ + "static/media/Tokio_Marine_-_White_Back@2x.252360b8.png";